import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { AlgoliaService } from '@app/core/services/algolia.service';

@Injectable()
export class ResultResolver implements Resolve<any> {
  client: any;
  index: any;

  constructor(
    private algoliaService: AlgoliaService
  ) { }

  resolve(route: ActivatedRouteSnapshot) {
    const searchedValue = route.params.searchedValue;

    return this.algoliaService.searchHits(searchedValue);
  }

}
